export default function HollowCandle(overlay, ctx, layout, data) {

    const green = data.raw[4] >= data.raw[1]
    const color = green ? overlay.upColor : overlay.downColor
    const wickColor = overlay.wickColor || color

    let w = Math.max(data.w, 1)
    let hw = Math.max(Math.floor(w * 0.5), 1)
    let h = Math.abs(data.o - data.c)
    let max_h = data.c === data.o ? 1 : 2
    let x05 = Math.floor(data.x) - 0.5

    // Draw wick
    ctx.strokeStyle = wickColor
    ctx.beginPath()
    ctx.moveTo(x05, Math.floor(data.h))
    ctx.lineTo(x05, Math.floor(data.l))
    ctx.stroke()

    if (data.w > 1.5) {
        let s = green ? 1 : -1
        let bodyX = Math.floor(data.x - hw - 1)
        let bodyW = Math.floor(hw * 2 + 1)
        let bodyH = s * Math.max(h, max_h)

        if (green) {
            // Hollow candle for bullish
            ctx.strokeStyle = color
            ctx.lineWidth = 1.5
            ctx.strokeRect(bodyX, data.c, bodyW, bodyH)
        } else {
            // Filled candle for bearish
            ctx.fillStyle = color
            ctx.fillRect(bodyX, data.c, bodyW, bodyH)
        }
    } else {
        ctx.strokeStyle = color
        ctx.beginPath()
        ctx.moveTo(x05, Math.floor(Math.min(data.o, data.c)))
        ctx.lineTo(x05, Math.floor(Math.max(data.o, data.c)) + (data.o === data.c ? 1 : 0))
        ctx.stroke()
    }
}
